import React, { useContext, useState } from 'react';
import { ToolbarContext, ModalContext } from 'ricos-context';
import { DECORATION_LINK_MODAL_ID } from 'wix-rich-content-toolbars-modals';
import { ToolbarButton } from 'wix-rich-content-toolbars-ui';

const EditLinkButton = ({ toolbarItem }) => {
  var _a, _b, _c;
  const { isMobile, t } = useContext(ToolbarContext);
  const modalService = useContext(ModalContext) || {};
  const [referenceElement, setReferenceElement] = useState(null);
  const openModal = () => {
    modalService.isModalOpen(DECORATION_LINK_MODAL_ID) ? modalService.closeModal(DECORATION_LINK_MODAL_ID) : modalService == null ? void 0 : modalService.openModal(DECORATION_LINK_MODAL_ID, {
      layout: isMobile ? "fullscreen" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      ref: setReferenceElement,
      isMobile,
      active: modalService.isModalOpen(DECORATION_LINK_MODAL_ID) || toolbarItem.attributes.active,
      tooltip: t((_a = toolbarItem.presentation) == null ? void 0 : _a.tooltip),
      onClick: openModal,
      Icon: (_b = toolbarItem.presentation) == null ? void 0 : _b.icon,
      dataHook: (_c = toolbarItem.presentation) == null ? void 0 : _c.dataHook
    }
  );
};

export { EditLinkButton };
//# sourceMappingURL=edit-link-button.js.map
